import { Navigate } from 'react-router-dom';

/**
 * Redirect an unauthenticated visitor to /auth.
 *
 * A failed OAuth callback (including a signup blocked by the invite-only
 * gate) stays in AuthContext as `oauthError`; the /auth page consumes and
 * clears it there. It is deliberately NOT passed as router state and NOT
 * cleared here: the previous clear-on-mount effect raced the Navigate,
 * re-rendered it with empty state, and the sign-in page showed no message
 * at all for any failed Google/Microsoft callback.
 */
export function AuthRedirect() {
  return <Navigate to="/auth" replace />;
}
